import "./NuevoNavReact.css";
import React, { useContext, useEffect, useState } from "react";
import { Badge, Button, OverlayTrigger, Popover } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { DarkModeContext } from "../../context/DarkModeContext";
import { FaBars } from "react-icons/fa";
import logo from "../../assets/img/logo.png";
import logoClaro from "../../assets/img/logo-modo-oscuro.png";
import notificacionesIcon from "../../assets/svg/notificaciones new.svg";
import perfilIcon from "../../assets/svg/perfil new.svg";
import exitIcon from "../../assets/svg/exit new.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
   faTableCells,
    faClipboardCheck,
  faBell,
  faCalculator,
  faCertificate,
  faChartSimple,
  faCheck,
  faCheckToSlot,
  faCircle,
  faCircleExclamation,
  faCommentDots,
  faFileArrowDown,
  faFileInvoiceDollar,
  faFilter,
  faGear,
  faGraduationCap,
  faHouse,
  faLink,
  faList,
  faListCheck,
  faLocationDot,
  faMagnifyingGlassChart,
  faMoon,
  faNewspaper,
  faReceipt,
  faRectangleList,
  faRightFromBracket,
  faStar,
  faSun,
  faTrashCan,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Link, NavLink, useLocation } from "react-router-dom";
import Select from "react-select";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import ModalConfiguracionesCel from "./ModalConfiguracionesCel";
import { DatosInicioContext } from "../../context/DatosInicioContext";
import Swal from "sweetalert2";
import NotificacionIndicador from "./NotificacionIndicador";
import { getToken } from "../../utils/auth";
import { obtenerBienvenidoPanel } from "../../helpers/bienvenidoPanelRequest";

const CRM_POSTVENTA_V2_COUNTER_URL = "/api/crm-postventa-v2/alertas/contador";
const CRM_POSTVENTA_V2_COUNTER_PATHS = [
  "/administracion/crm-postventa/seguimiento-2",
  "/administracion/crm-postventa-v2",
];

const logoutWarningIcon = (() => {
  const [width, height, , , path] = faCircleExclamation.icon;
  return `<svg class="logout-confirmation-swal__icon-svg" viewBox="0 0 ${width} ${height}" aria-hidden="true" focusable="false"><path d="${path}"></path></svg>`;
})();

const NuevoNavReact = ({ name, ...props }) => {
  const location = useLocation();

  const normalizePath = (value) => {
    const path = String(value || "").toLowerCase().trim();
    if (!path || path === "/") return "/";
    return path.endsWith("/") ? path.slice(0, -1) : path;
  };

  const getActiveClass = (isActive, dm) => {
    if (isActive) return dm ? "d-flex btn-grid-active-dark centrado" : "d-flex btn-grid-active centrado";
    return dm ? "d-flex btn-grid-dark centrado" : "d-flex btn-grid centrado";
  };

  const routeButtonClass = (pathOrPaths) => {
    const currentPath = normalizePath(location?.pathname);
    const candidates = Array.isArray(pathOrPaths) ? pathOrPaths : [pathOrPaths];
    const isActive = candidates
      .map((item) => normalizePath(item))
      .some((targetPath) => currentPath === targetPath || currentPath.startsWith(`${targetPath}/`));
    return getActiveClass(isActive, darkMode);
  };

  const renderNavIcon = (src, alt, className = "nav-action-icon") => (
    <img className={className} src={src} alt={alt} />
  );

  const crmPostventaPaths = [
    "/administracion/crm-postventa",
    "/administracion/crm-postventa/alertas",
    "/administracion/crm-postventa/ficha",
    "/administracion/crm-postventa/facturacion",
    "/administracion/crm-postventa/ordenes-pago",
    "/administracion/crm-postventa/cupones",
    "/administracion/crm-postventa/herramientas",
    "/administracion/crm-postventa/altas-bajas",
    "/administracion/crm-postventa/blanqueos",
    "/administracion/crm-postventa/gestion",
    "/administracion/crm-postventa/seguimiento",
    "/administracion/crm-postventa/seguimiento-2",
    "/administracion/crm-postventa/seguimiento-2/centro",
    "/administracion/crm-postventa/seguimiento-2/onboarding",
    "/administracion/crm-postventa/seguimiento-2/zoco-check",
    "/administracion/crm-postventa/seguimiento-2/sin-facturacion",
    "/administracion/crm-postventa/seguimiento-2/recupero",
    "/administracion/crm-postventa/seguimiento-2/extraviada",
    "/administracion/crm-postventa/seguimiento-2/automatizacion",
    "/administracion/crm-postventa/seguimiento-2/derivaciones",
    "/administracion/crm-postventa/seguimiento-2/historial",
    "/administracion/crm-postventa-v2/onboarding",
    "/administracion/crm-postventa-v2/zoco-check",
    "/administracion/crm-postventa-v2/terminal-sin-facturacion",
    "/administracion/crm-postventa-v2/recupero-terminal",
    "/administracion/crm-postventa-v2/terminal-extraviada",
    "/administracion/crm-postventa-v2/automatizacion",
    "/administracion/crm-postventa-v2/derivaciones",
    "/administracion/crm-postventa-v2/historial",
  ];

  const shouldLoadCrmPostventaV2Counter = CRM_POSTVENTA_V2_COUNTER_PATHS.some((path) => {
    const normalizedPath = normalizePath(path);
    const currentPath = normalizePath(location?.pathname);
    return currentPath === normalizedPath || currentPath.startsWith(`${normalizedPath}/`);
  });

  const crmPostventaLinks = [
    {
      path: "/administracion/crm-postventa/alertas",
      label: "Alertas",
      icon: faBell,
    },
    {
      path: "/administracion/crm-postventa/altas-bajas",
      label: "Altas / Bajas",
      icon: faTableCells,
    },
    {
      path: "/administracion/crm-postventa/blanqueos",
      label: "Blanqueos",
      icon: faCheckToSlot,
    },
    {
      path: "/administracion/crm-postventa/ficha",
      label: "Ficha del cliente",
      icon: faHouse,
    },
    {
      path: "/administracion/crm-postventa/facturacion",
      label: "Facturación",
      icon: faChartSimple,
    },
    {
      path: "/administracion/crm-postventa/ordenes-pago",
      label: "Órdenes de pago",
      icon: faFileInvoiceDollar,
    },
    {
      path: "/administracion/crm-postventa/cupones",
      label: "Cupones",
      icon: faReceipt,
    },
    {
      path: "/administracion/crm-postventa/herramientas",
      label: "Herramientas",
      icon: faGear,
    },
    {
      path: "/administracion/crm-postventa/gestion",
      label: "Gestión",
      icon: faClipboardCheck,
    },
    {
      path: "/administracion/crm-postventa/seguimiento",
      label: "Seguimiento",
      icon: faListCheck,
    },
    {
      path: "/administracion/crm-postventa/seguimiento-2",
      label: "Seguimiento 2",
      icon: faClipboardCheck,
      activePaths: [
        "/administracion/crm-postventa/seguimiento-2",
        "/administracion/crm-postventa-v2",
      ],
    },
  ];

  const crmViejoLinksAdmin = [
    {
      path: "/administracion/crm-seguimiento",
      label: "CRM Seguimiento",
      icon: faHouse,
    },
    {
      path: "/administracion/notificaciones",
      label: "Notificaciones",
      icon: faBell,
    },
    {
      path: "/administracion/popup",
      label: "Crear Modales",
      icon: faCertificate,
    },
    {
      path: "/administracion/blanqueos",
      label: "Blanqueos",
      icon: faCertificate,
    },
    {
      path: "/administracion/peticiones",
      label: "Peticiones",
      icon: faListCheck,
    },
    {
      path: "/administracion/crm",
      label: "CRM",
      icon: faTableCells,
    },
    {
      path: "/administracion/legajos",
      label: "Legajos",
      icon: faNewspaper,
    },
    {
      path: "/admin/listaordenpago",
      label: "Órdenes de pago",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/nrocomercio",
      label: "Número comercio",
      icon: faRectangleList,
    },
    {
      path: "/administracion/bancos",
      label: "Bancos",
      icon: faRectangleList,
    },
    {
      path: "/administracion/rubros",
      label: "Rubros",
      icon: faRectangleList,
    },
    {
      path: "/administracion/AdminCupones",
      label: "Cupones",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/importacion-operaciones",
      label: "Importación Ops",
      icon: faFileArrowDown,
    },
    {
      path: "/administracion/conciliacion-operaciones",
      label: "Conciliación Ops",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/AdminResumenAliado",
      label: "Resumen aliado",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/AdminPanelInterno",
      label: "Panel interno",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/Fidelizacion",
      label: "Fidelización",
      icon: faMagnifyingGlassChart,
    },
    {
      path: "/administracion/AdminSimulador",
      label: "Comparador",
      icon: faChartSimple,
    },
    {
      path: "/administracion/AdminComparador",
      label: "Simulador",
      icon: faCalculator,
    },
    {
      path: "/admin/Simuladorliquidacion",
      label: "Simulador de órdenes",
      icon: faCalculator,
      activePaths: ["/admin/Simuladorliquidacion", "/administracion/simuladorliquidacion"],
    },
    {
      path: "/admin/excepcion-anticipo",
      label: "Excepción anticipo",
      icon: faTableCells,
    },
    {
      path: "/admin/terminales-excepcion-anticipo",
      label: "Terminales anticipo",
      icon: faTableCells,
    },
  ];

  const crmViejoPathsAdmin = crmViejoLinksAdmin.flatMap((item) => {
    const paths = item.activePaths || item.path;
    return Array.isArray(paths) ? paths : [paths];
  });

  const isGroupActive = (pathOrPaths) => {
    const currentPath = normalizePath(location?.pathname);
    const candidates = Array.isArray(pathOrPaths) ? pathOrPaths : [pathOrPaths];
    return candidates
      .map((item) => normalizePath(item))
      .some((targetPath) => currentPath === targetPath || currentPath.startsWith(`${targetPath}/`));
  };

  //states del sidebar
  const [show, setShow] = useState(false);
  const [crmViejoOpenAdmin, setCrmViejoOpenAdmin] = useState(false);
  const handleClose = () => setShow(false);

  const toggleShow = () => setShow((s) => !s);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setShow(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isGroupActive(crmViejoPathsAdmin)) {
      setCrmViejoOpenAdmin(true);
    }
  }, [location.pathname]);

  const { darkMode } = useContext(DarkModeContext);
  const [datoCapturados, setDatoCapturados] = useState({});
  const [isSearchable, setIsSearchable] = useState(true);
  const [selectedAnio, setSelectedAnio] = useState(null);
  const [selectedMes, setSelectedMes] = useState(null);
  const [selectedComercio, setSelectedComercio] = useState(null);
  const [selectedSemana, setSelectedSemana] = useState(null);
  const [visibleModal, setVisibleModal] = useState(false);
  const { actualizarDatos } = useContext(DatosInicioContext);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [optionsComercio, setOptionsComercio] = useState([]);
  const [optionsAnios, setOptionsAnios] = useState([]);
  const [optionsMes, setOptionsMes] = useState([]);
  const [optionsSemanas, setOptionsSemanas] = useState([]);
  const [crmPostventaCounter, setCrmPostventaCounter] = useState({
    total: 0,
    nuevas: 0,
    vencidas: 0,
    criticas: 0,
    compliance: 0,
    refreshSeconds: 60,
  });

  const [datosSelect, setDatosSelect] = useState({
    anio: "",
    mes: "",
    semana: "",
    comercio: "",
  });

  const enviarDatosAlContexto = (datos) => {
    actualizarDatos(datos);
  };

  const procesarDatos = (data) => {
    const optionsComercio = [
      ...data.comercios.map((comercio) => ({
        value: comercio.toLowerCase().replace(/\s+/g, ""),
        label: comercio,
      })),
    ];

    const fechaInicio = new Date(data.fechaInicio);
    const fechaFin = new Date(data.fechaFin);

    const optionsAnios = [];
    for (
      let año = fechaInicio.getFullYear();
      año <= fechaFin.getFullYear();
      año++
    ) {
      optionsAnios.push({ value: año.toString(), label: año.toString() });
    }
    const optionsSemanas = [{ value: 8, label: "Todos" }];
    const optionsMeses = [];
    let fechaActual = fechaInicio;
    while (fechaActual <= fechaFin) {
      const mes = fechaActual.toLocaleString("es", { month: "long" });
      optionsMeses.push({ value: fechaActual.getMonth() + 1, label: mes });
      fechaActual = new Date(
        fechaActual.getFullYear(),
        fechaActual.getMonth() + 1,
        1
      );
      if (selectedAnio === null) {
        const ultimoAnio = optionsAnios[optionsAnios.length - 1];
        const ultimoMes = optionsMeses[optionsMeses.length - 1];

        setSelectedAnio(ultimoAnio);
        setSelectedMes(ultimoMes);
        setSelectedSemana(optionsSemanas[0]);
      }

      // Establecer 'Todos' como valor predeterminado para comercio
      setSelectedComercio(optionsComercio[0]);
    }

    setOptionsComercio(optionsComercio);
    setOptionsAnios(optionsAnios);
    setOptionsMes(optionsMeses);
    setOptionsSemanas(optionsSemanas);
    setFechaInicio(fechaInicio);
    setFechaFin(fechaFin);
  };

  const apiUrlBienvenidoPanel = process.env.REACT_APP_API_BIENVENIDO_PANEL;

  // consulta compartida con BienvenidoPanel: evita repetir el POST en cada montaje
  useEffect(() => {
    const token = getToken();

    if (token) {
      obtenerBienvenidoPanel(apiUrlBienvenidoPanel, token)
        .then(({ datos, error }) => {
          if (error) {
            throw error;
          }
          procesarDatos(datos);
        })
        .catch((error) => {
        });
    }
  }, []);
  const actualizarMesesPorAnio = (anioSeleccionado) => {
    if (!fechaInicio || !fechaFin) return;

    // Ajusta el mes de inicio y fin dependiendo del año seleccionado
    const mesInicio =
      anioSeleccionado === fechaInicio.getFullYear()
        ? fechaInicio.getMonth()
        : 0;
    const mesFin =
      anioSeleccionado === fechaFin.getFullYear() ? fechaFin.getMonth() : 11;

    const optionsMeses = [];
    for (let mes = mesInicio; mes <= mesFin; mes++) {
      let fechaActual = new Date(anioSeleccionado, mes, 1);
      const nombreMes = fechaActual.toLocaleString("es", { month: "long" });
      optionsMeses.push({ value: mes + 1, label: nombreMes }); // Usar mes + 1 como valor
    }

    setOptionsMes(optionsMeses);

    // Establecer setSelectedMes en el último mes del rango
    setSelectedMes(optionsMeses[optionsMeses.length - 1]);
  };

  const actualizarSemanasPorMes = (anioSeleccionado, mesSeleccionado) => {
    const primerDiaMes = new Date(anioSeleccionado, mesSeleccionado - 1, 1);
    const ultimoDiaMes = new Date(anioSeleccionado, mesSeleccionado, 0);

    // Ajustar al lunes de la misma semana solo si el primer día no es domingo
    let diaActual = new Date(primerDiaMes);
    if (primerDiaMes.getDay() !== 0) {
      diaActual.setDate(diaActual.getDate() - ((diaActual.getDay() + 6) % 7));
    }

    let semanas = [];
    let semana = [];
    let numeroSemanaDelMes = 0;

    // Iterar a través de los días
    while (diaActual <= ultimoDiaMes || semana.length > 0) {
      if (diaActual.getDay() === 1) {
        if (semana.length > 0) {
          semanas.push({ numeroSemanaDelMes, dias: [...semana] });
          semana = [];
        }
        numeroSemanaDelMes++;
      }

      // Añadir el día a la semana actual si está dentro del mes
      if (diaActual.getMonth() === mesSeleccionado - 1) {
        semana.push(new Date(diaActual));
      }

      diaActual.setDate(diaActual.getDate() + 1);

      // Añadir la última semana si hemos llegado al final del mes
      if (diaActual > ultimoDiaMes && semana.length > 0) {
        semanas.push({ numeroSemanaDelMes, dias: [...semana] });
        semana = [];
      }
    }

    // Agregar el texto del mes completo al principio
    const mesCompleto = { label: `Todo el Mes`, value: 8 };

    // Filtrar las semanas que caen dentro del rango de fechaInicio y fechaFin
    const semanasFiltradas = semanas.filter((semana) => {
      const inicioSemana = semana.dias[0];
      const finSemana = semana.dias[semana.dias.length - 1];
      return (
        (!fechaInicio || finSemana >= fechaInicio) &&
        (!fechaFin || inicioSemana <= fechaFin)
      );
    });

    // Formatear las semanas para el uso en el front-end
    const semanasFormateadas = semanasFiltradas.map((semana) => {
      const label = `Semana ${semana.numeroSemanaDelMes}`;
      const value = semana.numeroSemanaDelMes;

      return { label, value };
    });

    // Agregar el objeto del mes completo al principio de la matriz
    semanasFormateadas.unshift(mesCompleto);

    setOptionsSemanas(semanasFormateadas);
  };

  // Al cargar, las semanas del mes seleccionado se calculan con la misma
  // funcion que usa el panel de filtros web (actualizarSemanasPorMes), en
  // lugar de quedarse con la lista inicial de una sola opcion. Igual que en
  // web, tambien se recalcula cuando cambia el anio o el mes.
  useEffect(() => {
    if (!fechaInicio || !fechaFin) return;
    if (!selectedAnio || !selectedMes) return;

    actualizarSemanasPorMes(
      Number(selectedAnio.value),
      Number(selectedMes.value)
    );
  }, [fechaInicio, fechaFin, selectedAnio, selectedMes]);

  // Mantiene seleccionada la opcion que agrupa todo el mes (value 8) usando
  // el objeto que devuelve la lista recalculada, como hace el panel web.
  useEffect(() => {
    if (!optionsSemanas.length) return;
    if (selectedSemana && selectedSemana.value !== 8) return;

    const todoElMes = optionsSemanas.find((semana) => semana.value === 8);
    if (todoElMes && todoElMes !== selectedSemana) {
      setSelectedSemana(todoElMes);
    }
  }, [optionsSemanas]);

  const mandarSemana = (selectedSemana) => {
    const valorSemanaSeleccionada = selectedSemana;
    setDatosSelect({
      ...datosSelect,
      semana: valorSemanaSeleccionada,
    });
  };

  const mandarComercio = (selectedComercio) => {
    const valorComercioSeleccionado = selectedComercio;
    setDatosSelect({
      ...datosSelect,
      comercio: valorComercioSeleccionado,
    });
  };

  useEffect(() => {
    setDatosSelect({
      anio: selectedAnio ? selectedAnio.value : 0,
      mes: selectedMes ? selectedMes.value : "",
      semana: selectedSemana ? selectedSemana.value : 8, // Usar un valor por defecto aquí
      comercio: selectedComercio ? selectedComercio.value : "",
    });
  }, [selectedAnio, selectedMes, selectedSemana, selectedComercio]);

  const handleEnviarDatos = () => {
    if (!selectedAnio || !selectedMes || !selectedSemana || !selectedComercio) {
      Swal.fire({
        title: "Error",
        text: "Por favor, selecciona todos los campos.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    setIsLoading(true); // Iniciar el indicador de carga
    enviarDatosAlContexto({
      anio: Number(selectedAnio.value),
      mes: Number(selectedMes.value),
      semana: Number(selectedSemana.value),
      comercio: selectedComercio.value,
    });
    setTimeout(() => {
      setIsLoading(false); 
      setVisibleModal(false); 
      handleClose2();
    }, 2000); 
  };

  // Estilos del panel de filtros responsive (solo presentacion).
  const filtrosSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 47,
      height: 47,
      borderRadius: 8,
      border: "1px solid #34383d",
      backgroundColor: "#ffffff",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": { borderColor: "#34383d" },
    }),
    valueContainer: (base) => ({ ...base, padding: "0 16px" }),
    singleValue: (base) => ({
      ...base,
      color: "#292c31",
      fontSize: 15,
      textAlign: "left",
    }),
    // El nombre del campo se muestra dentro del selector, en oscuro.
    placeholder: (base) => ({
      ...base,
      color: "#292c31",
      fontSize: 15,
      textAlign: "left",
    }),
    input: (base) => ({ ...base, color: "#292c31" }),
    indicatorSeparator: () => ({ display: "none" }),
    indicatorsContainer: (base) => ({ ...base, height: 47 }),
    dropdownIndicator: (base) => ({ ...base, color: "#34383d", paddingRight: 12 }),
    // Mismo desplegable que ya usa el panel de filtros web.
    menu: (base) => ({
      ...base,
      marginTop: 6,
      borderRadius: 10,
      overflow: "hidden",
      boxShadow: "0 12px 28px rgba(18, 24, 32, 0.16)",
    }),
    menuList: (base) => ({
      ...base,
      padding: 6,
      backgroundColor: "#ffffff",
      // Altura limitada + scroll interno: el modal no cambia de alto.
      maxHeight: 220,
      overflowY: "auto",
    }),
    // El menu se renderiza en un portal para que flote sobre el modal
    // sin agrandarlo; por encima del overlay (z-index 1400).
    menuPortal: (base) => ({ ...base, zIndex: 1500 }),
    option: (base, state) => ({
      ...base,
      borderRadius: 7,
      backgroundColor: state.isSelected
        ? "#2D3035"
        : state.isFocused
        ? "#EDF0F2"
        : "transparent",
      color: state.isSelected ? "#ffffff" : "#2D3035",
      cursor: "pointer",
      fontSize: 13,
      padding: "10px 12px",
    }),
  };

  // Borrar filtros: vuelve los selectores a "sin seleccion", el mismo
  // estado inicial que ya tienen al montarse, y limpia el filtro guardado
  // en sessionStorage tal como se hace hoy al recargar. No agrega logica
  // de negocio ni consultas nuevas.
  const handleBorrarFiltros = () => {
    setSelectedAnio(null);
    setSelectedMes(null);
    setSelectedSemana(null);
    setSelectedComercio(null);
    sessionStorage.removeItem("filtrosSeleccionados");
  };

  const [isLoading, setIsLoading] = useState(false);
  const verModalFilter = () => {
    setVisible2(false);
    setVisible1(false);
    setVisibleModal(!visibleModal);
  };

  const [visible1, setVisible1] = useState(false);
  const verModalNotificacion = () => {
    setVisible1(!visible1);
    setVisible2(false);
  };

  const [visible2, setVisible2] = useState(false);
  const verModalCerrarSesion = () => {
    setVisible2(!visible2);
    setVisible1(false);
  };

  const activadoIconoCampana = () => {
    if (visible1 && darkMode) {
      return " iconos-modales cursor-point text-white mx-3";
    } else if (visible1) {
      return " iconos-modales cursor-point text-dark mx-3";
    } else if (darkMode) {
      return "iconos-modales cursor-point  mx-3 color-verde";
    } else {
      return "iconos-modales cursor-point  mx-3 color-verde";
    }
  };

  const activadoIconoUser = () => {
    if (visible2 && darkMode) {
      return " iconos-modales cursor-point text-white mx-3";
    } else if (visible2) {
      return " iconos-modales cursor-point text-dark mx-3";
    } else if (darkMode) {
      return "iconos-modales cursor-point  mx-3 color-verde";
    } else {
      return "iconos-modales cursor-point  mx-3 color-verde";
    }
  };

  const { toggleDarkMode } = useContext(DarkModeContext);

  const aparecerScroll = () => {
    setShow(false);
  };


  const handleClick = () => {
    toggleDarkMode();
    setVisible2(false);
    setVisible1(false);
  };

  const reloadPage = () => {
    window.location.reload = "/";
  };

  const [modalShowCompleta, setModalShowCompleta] = React.useState(false);
  const [mostrarOffcanvas, setMostrarOffcanvas] = useState(false);

  const cerrarOffcanvas = () => {
    setMostrarOffcanvas(false);
  };

  const otroEvento = () => {
    setVisible1(false);
    setVisible2(false);
  };

  const handleClose2 = () => {
    cerrarOffcanvas();
    otroEvento();
  };

  const loadCrmPostventaCounter = async () => {
    const token = getToken();
    if (!token) return;

    try {
      const response = await fetch(CRM_POSTVENTA_V2_COUNTER_URL, {
        method: "GET",
        headers: {
          "X-CRM-Token": token,
        },
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          return;
        }

        throw new Error(`Error ${response.status}`);
      }

      const data = await response.json();
      setCrmPostventaCounter((prev) => ({
        ...prev,
        ...data,
      }));
    } catch (_) {}
  };

  const renderMobileNavLink = ({ path, label, icon, activePaths, child = false, badge = null }) => (
    <div className={`centrado my-2${child ? " crm-menu-child" : ""}`} key={path}>
      <NavLink
        end
        to={path}
        className="border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={routeButtonClass(activePaths || path)}>
            <div className="icono">
              <FontAwesomeIcon icon={icon} />
            </div>
            <div className="texto custom-badge-container">
              <span className="lato-bold fs-14">{label}</span>
              {badge ? <Badge className="custom-badge" bg="danger">{badge}</Badge> : null}
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  );

  const apiUrlNotificaciones = process.env.REACT_APP_API_NOTIFICACIONES;
  const apiUrlLogout = process.env.REACT_APP_API_LOGOUT;
  const apiUrlToken = process.env.REACT_APP_API_TOKEN;
  const apiUrlTokenDemo = process.env.REACT_APP_API_TOKEN_DEMO;

  const [notificacionesAliados, setNotificacionesAliados] = useState([]);
  const [notificacionesAsesores, setNotificacionesAsesores] = useState([]);

    useEffect(() => {
        const fetchNoticias = async () => {
            try {
                const response = await fetch(apiUrlNotificaciones);

                // Verificar que la respuesta sea "ok"
                if (!response.ok) {
                }

                const data = await response.json();

                // Verificar que data no esté vacío
                if (!data || data.length === 0) {
                    return;
                }

                // Filtrar notificaciones por tipo de usuario
                const noticiasAliados = data.filter(
                    (notificacion) => notificacion.tipoUsuario.trim() === "Aliado"
                );
                const noticiasAsesores = data.filter(
                    (notificacion) => notificacion.tipoUsuario.trim() === "Asesor"
                );

                // Actualizar estados con notificaciones filtradas
                setNotificacionesAliados(noticiasAliados);
                setNotificacionesAsesores(noticiasAsesores);
            } catch (error) {
            }
        };

        fetchNoticias();
    }, [apiUrlNotificaciones]); 

  const [hayNotificacionesNoVistas, setHayNotificacionesNoVistas] =
    useState(true);
  const [usuarioRol, setUsuarioRol] = useState();
  const currentNotifications = usuarioRol === 0 ? notificacionesAliados : notificacionesAsesores;
  // Los ajustes de la sidebar chica solo aplican al area de Aliados (rol 0).
  const esSidebarAliado = Number(usuarioRol) === 0;
  const [mostrarMenuDemoAliado, setMostrarMenuDemoAliado] = useState(false);

  useEffect(() => {
    if (![2, 8, 13].includes(Number(usuarioRol)) || !shouldLoadCrmPostventaV2Counter) {
      return undefined;
    }

    loadCrmPostventaCounter();

    const refreshSeconds = Number(crmPostventaCounter?.refreshSeconds || 60);
    if (!Number.isFinite(refreshSeconds) || refreshSeconds < 15) {
      return undefined;
    }

    const timer = window.setInterval(loadCrmPostventaCounter, refreshSeconds * 1000);
    return () => window.clearInterval(timer);
  }, [usuarioRol, crmPostventaCounter?.refreshSeconds, shouldLoadCrmPostventaV2Counter]);

  useEffect(() => {
    const verificarDemo = async () => {
      const token = getToken();
      if (!token) {
        setMostrarMenuDemoAliado(false);
        return;
      }

      try {
        const response = await fetch(apiUrlTokenDemo, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Token: token }),
        });

        setMostrarMenuDemoAliado(response.status === 200);
      } catch (error) {
        setMostrarMenuDemoAliado(false);
      }
    };

    verificarDemo();
  }, []);

  useEffect(() => {
    const verificarToken = async () => {
      const token = getToken();

      try {
        const response = await fetch(apiUrlToken, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Token: token }),
        });

        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }

        const datosRecibido = await response.json();
        setUsuarioRol(datosRecibido);
        // Aquí puedes hacer algo con el rol
        // Por ejemplo, guardarlo en el estado o realizar alguna lógica basada en el rol
      } catch (error) {
        console.error("Error al validar el token", error);
      }
    };

    verificarToken();
  }, [usuarioRol]);

  // funcion para borrar el token y cerrar sesion
  const cerrarSesion = async () => {
    const token = getToken();
    if (!token) {
      console.error("No hay token en el almacenamiento de la sesión");
      return;
    }

    try {
      const response = await fetch(apiUrlLogout, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Token: token }),
      });

      if (response.ok) {
        
        // Aquí puedes redireccionar al usuario o realizar otras acciones necesarias después de cerrar sesión
        sessionStorage.removeItem("token"); // Eliminar el token del sessionStorage
        // Redireccionar al usuario, por ejemplo a la página de inicio de sesión
        window.location.href = "/";
      } else {
        console.error("Error al cerrar sesión:", await response.text());
      }
    } catch (error) {
      console.error(
        "Error al realizar la solicitud de cierre de sesión:",
        error
      );
    }
  };

  const confirmarCerrarSesion = () => {
    const isAliadosLogout =
      location.pathname.startsWith("/aliados") || esSidebarAliado;

    const logoutConfirmationOptions = isAliadosLogout
      ? {
          html: `<div class="logout-confirmation-swal__message">¿Cerrar sesión<br />en <span class="logout-confirmation-swal__brand"><img class="logout-confirmation-swal__brand-logo" src="${logo}" alt="ZOCO" /></span>?</div>`,
          icon: "warning",
          iconHtml: logoutWarningIcon,
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          customClass: {
            container: darkMode
              ? "swal2-container--dark logout-confirmation-swal"
              : "swal2-container--light logout-confirmation-swal",
            popup: "logout-confirmation-swal__popup",
            icon: "logout-confirmation-swal__icon",
            htmlContainer: "logout-confirmation-swal__html",
            actions: "logout-confirmation-swal__actions",
            confirmButton: "logout-confirmation-swal__confirm",
            cancelButton: "logout-confirmation-swal__cancel",
          },
        }
      : {
          title: "¿Estás seguro?",
          imageUrl: logo,
          imageWidth: 100,
          imageHeight: 30,
          imageAlt: "Logo",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          customClass: {
            container: darkMode
              ? "swal2-container--dark"
              : "swal2-container--light",
            confirmButton: "my-swal-button",
            cancelButton: "my-swal-button2",
          },
        };

    Swal.fire(logoutConfirmationOptions).then((result) => {
      if (result.isConfirmed) {
        cerrarSesion();
      }
    });
  };

  const menusPorRol = {
    // aliado menu
    0: (
      <>
        <div className="mt-4">
          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/inicio"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/inicio")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faHouse} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14"> Inicio</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/contabilidad"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/contabilidad")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faFileInvoiceDollar} />
                  </div>
                  <div className="texto custom-badge-container">
                    <span className="lato-bold fs-14"> Contabilidad</span>
                    {/*<Badge className="custom-badge" bg="danger">*/}
                    {/*  Nuevo*/}
                    {/*</Badge>*/}
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/analisis"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/analisis")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14">Análisis</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/cupones"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/cupones")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faReceipt} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14">Cupones</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/calculadora"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/calculadora")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faCalculator} />
                  </div>
                  <div className="texto custom-badge-container">
                    <span className="lato-bold fs-14">Simulador</span>
                    {/*<Badge className="custom-badge" bg="danger">*/}
                    {/*  Nuevo*/}
                    {/*</Badge>*/}
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/consultas"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/consultas")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faCheckToSlot} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14">Consultas</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>
          <div className="centrado my-2">
            <NavLink
              end
              to="/aliados/buscador-cupones-interno"
              className=" border-0 text-decoration-none"
              onClick={() => {
                handleClose2();
                aparecerScroll();
              }}
            >
              <div style={{ width: "160px" }}>
                <div className={routeButtonClass("/aliados/buscador-cupones-interno")}>
                  <div className="icono">
                    <FontAwesomeIcon icon={faReceipt} />
                  </div>
                  <div className="texto">
                    <span className="lato-bold fs-14">Buscador de cupones</span>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          {/* Chat IA: la funcionalidad todavia no esta desarrollada,
              se muestra deshabilitada y no navega a ningun lado. */}
          <div className="centrado my-2">
            <div style={{ width: "160px" }}>
              <div
                className={
                  darkMode
                    ? "d-flex btn-grid-dark btn-grid-deshabilitado"
                    : "d-flex btn-grid btn-grid-deshabilitado"
                }
                aria-disabled="true"
              >
                <div className="icono">
                  <FontAwesomeIcon icon={faCommentDots} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Chat IA</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="centrado my-2"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <a
              href="https://wa.link/w4quzx"
              target="_blank"
              rel="noreferrer"
              className=" border-0 text-decoration-none"
              style={{ width: "160px" }}
            >
              <div
                className={
                  darkMode ? " d-flex btn-grid-dark " : " d-flex btn-grid "
                }
              >
                <div className="icono">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Postventa</span>
                </div>
              </div>
            </a>
          </div>
          <div className="centrado my-2">
            <button
              onClick={confirmarCerrarSesion}
              style={{ width: "160px" }}
              className={
                darkMode
                  ? "d-flex  border-0 btn-grid-menu-dark centrado"
                  : "d-flex  border-0 btn-grid-menu centrado"
              }
            >
              <div className="icono">
                {renderNavIcon(exitIcon, "Salir", "nav-action-icon nav-menu-icon")}
              </div>
              <div className="texto">
                <span className="lato-bold fs-14">Salir</span>
              </div>
            </button>
          </div>
        </div>
      </>
    ),
    // menu asesor
    1: (
      // asesor menu
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/check"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/check")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Check</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/simulador"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/simulador")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faChartSimple} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Comparador</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/chat"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/chat")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCommentDots} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Chat</span>
                </div>
              </div>
            </div>
          </NavLink>
            </div>
            <div className="centrado my-2">
                <NavLink
                    end
                    to="/asesores/crm"
                    className=" border-0 text-decoration-none"
                    onClick={() => {
                        handleClose2();
                        aparecerScroll();
                    }}
                >
                    <div style={{ width: "160px" }}>
                        <div className={routeButtonClass("/asesores/crm")}>
                            <div className="icono">
                                <FontAwesomeIcon icon={faChartSimple} />
                            </div>
                            <div className="texto">
                                <span className="lato-bold fs-14">CRM</span>
                            </div>
                        </div>
                    </div>
                </NavLink>
            </div>
        {/* <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/chat"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/chat")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCommentDots} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-16">Chat</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div> */}
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/descargas"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/descargas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faFileArrowDown} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Descargas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/academy"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/academy")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faGraduationCap} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Academy</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/criterios"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/criterios")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCertificate} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Criterios</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/asesores/calculadora"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/asesores/calculadora")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCalculator} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14">Simulador</span>
                  {/*<Badge className="custom-badge" bg="danger">*/}
                  {/*  Nuevo*/}
                  {/*</Badge>*/}
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
            </div>
          
      </>
    ),
    // menu para liquidaciones
    2: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Blanqueo</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/Buscador/Cupones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/Buscador/Cupones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Cupones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/ordenes/pago"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/ordenes/pago")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Orden de pago</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/peticiones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/peticiones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Peticiones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/facturante"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/facturante")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Factura</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/afip"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/afip")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">IVA-Ganancia</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/iibb"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/iibb")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">IIBB</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/tasas-competencia"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/tasas-competencia")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faTableCells} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Tasas Competencia</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/liquidaciones/tasas-zoco"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/liquidaciones/tasas-zoco")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faTableCells} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Tasas Zoco</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
      ), 3: (
          <>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/Admin"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Admin")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faHouse} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Check</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
         
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/peticiones"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/peticiones")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faListCheck} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Peticiones</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/PanelInterno"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/PanelInterno")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Panel  Gestores</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/PanelControlInterno"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/PanelControlInterno")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Panel  Interno</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/Historial"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Historial")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Historial CRM</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
         
              <div className="centrado my-2">

                  <NavLink
                      end
                    to="/Calidad/crm"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/crm")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> CRM</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/AdminLegajos"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/AdminLegajos")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Legajos</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/AdminNroComercio"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/AdminNroComercio")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faRectangleList} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Numero Comercio</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                    to="/Calidad/Auditorias"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/Calidad/Auditorias")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faRectangleList} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Panel Auditorias</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),
    // menu para reclutador
    4: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/reclutamiento/busqueda"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/reclutamiento/busqueda")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Busqueda</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/reclutamiento/contratados"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/reclutamiento/contratados")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCheckToSlot} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Contratados</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/reclutamiento/puestos"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/reclutamiento/puestos")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faList} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Puestos</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    ),
    5:(
      <>
      <div className="centrado my-2">
              <NavLink
                  end
                  to="/Admin"
                  className=" border-0 text-decoration-none"
                  onClick={() => {
                    handleClose2();
                    aparecerScroll();
                  }}
              >
                  <div style={{ width: "160px" }}>
                      <div className={routeButtonClass("/Admin")}>
                          <div className="icono">
                              <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                          </div>
                          <div className="texto">
                              <span className="lato-bold fs-14">Inicio</span>
                          </div>
                      </div>
                  </div>
              </NavLink>
          </div>

          <div className="centrado my-2">
              <NavLink
                  end
                  to="/reporte/ReporteMensual"
                  className=" border-0 text-decoration-none"
                  onClick={() => {
                    handleClose2();
                    aparecerScroll();
                  }}
              >
                  <div style={{ width: "160px" }}>
                      <div className={routeButtonClass("/reporte/ReporteMensual")}>
                          <div className="icono">
                              <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                          </div>
                          <div className="texto">
                              <span className="lato-bold fs-14">Reporte Mensual</span>
                          </div>
                      </div>
                  </div>
              </NavLink>
          </div>

          <div className="centrado my-2">
              <NavLink
                  end
                  to="/Admin/MonitoreoDiarioCuit"
                  className=" border-0 text-decoration-none"
                  onClick={() => {
                    handleClose2();
                    aparecerScroll();
                  }}
              >
                  <div style={{ width: "160px" }}>
                      <div className={routeButtonClass("/Admin/MonitoreoDiarioCuit")}>
                          <div className="icono">
                              <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                          </div>
                          <div className="texto">
                              <span className="lato-bold fs-14">Monitoreo Diario</span>
                          </div>
                      </div>
                  </div>
              </NavLink>
          </div>

          <div className="centrado my-2">
              <NavLink
                  end
                  to="/Admin/ComerciosRiesgo"
                  className=" border-0 text-decoration-none"
                  onClick={() => {
                    handleClose2();
                    aparecerScroll();
                  }}
              >
                  <div style={{ width: "160px" }}>
                      <div className={routeButtonClass("/Admin/ComerciosRiesgo")}>
                          <div className="icono">
                              <FontAwesomeIcon icon={faChartSimple} />
                          </div>
                          <div className="texto">
                              <span className="lato-bold fs-14">Comercios Riesgo</span>
                          </div>
                      </div>
                  </div>
              </NavLink>
          </div>

          <div className="centrado my-2">
              <NavLink
                  end
                  to="/Admin/CuitVinculados"
                  className=" border-0 text-decoration-none"
                  onClick={() => {
                    handleClose2();
                    aparecerScroll();
                  }}
              >
                  <div style={{ width: "160px" }}>
                      <div className={routeButtonClass("/Admin/CuitVinculados")}>
                          <div className="icono">
                              <FontAwesomeIcon icon={faLink} />
                          </div>
                          <div className="texto">
                              <span className="lato-bold fs-14">CUIT Vinculados</span>
                          </div>
                      </div>
                  </div>
              </NavLink>
          </div>
        
      </>
  ),
    // menu para gestor/a
    6: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/check"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/check")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Check</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/academy"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/academy")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Academy</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/peticiones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/peticiones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Peticiones</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        {/* <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/formularios"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={activadoCalificar()}>
                <div className="icono">
                  <FontAwesomeIcon icon={faListCheck} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Formularios</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div> */}
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/simulador"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/simulador")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faChartSimple} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Comparador</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/calculadora"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/calculadora")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCalculator} />
                </div>
                <div className="texto custom-badge-container">
                  <span className="lato-bold fs-14">Simulador</span>
                  <Badge className="custom-badge" bg="danger">
                    Nuevo
                  </Badge>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/gestor/descargas"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/gestor/descargas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faFileArrowDown} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Descargas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    ),
    // menu administrador/auditor
      8: (
          <>
              {crmPostventaLinks.map((item) => renderMobileNavLink({
                ...item,
                badge: null,
              }))}

              <div className="centrado my-2">
                  <button
                      type="button"
                      onClick={() => setCrmViejoOpenAdmin((prev) => !prev)}
                      style={{ width: "160px" }}
                      className={`${routeButtonClass(crmViejoPathsAdmin)} border-0 crm-menu-toggle ${crmViejoOpenAdmin ? "is-open" : ""}`}
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faList} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">CRM viejo</span>
                          <span className="crm-menu-caret">{crmViejoOpenAdmin ? "−" : "+"}</span>
                      </div>
                  </button>
              </div>

              {crmViejoOpenAdmin ? (
                  <div className="crm-menu-children crm-menu-children-collapsible">
                      {crmViejoLinksAdmin.map((item) => renderMobileNavLink({ ...item, child: true }))}
                  </div>
              ) : null}

              {false && (
                  <>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/crm-seguimiento"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/crm-seguimiento")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faHouse} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> CRM Seguimiento</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              {/*    <div className="centrado my-2">
      <NavLink
        end
        to="/administracion/chat"
        className=" border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={activadoCalificar()}>
            <div className="icono">
              <FontAwesomeIcon icon={faCommentDots} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Chat</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div>
    <div className="centrado my-2">
      <NavLink
        end
        to="/administracion/notificaciones"
        className=" border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={activado()}>
            <div className="icono">
              <FontAwesomeIcon icon={faHouse} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14"> Notificaciones</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div>
    <div className="centrado my-2">
      <NavLink
        end
        to="/administracion/calificaciones"
        className=" border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={activado()}>
            <div className="icono">
              <FontAwesomeIcon icon={faStar} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14"> Calificaciones</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div>*/}
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/blanqueos"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/blanqueos")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Blanqueos</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              {/*<div className="centrado my-2">
      <NavLink
        end
        to="/administracion/blanqueos/empleados"
        className=" border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={activado()}>
            <div className="icono">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14"> Empleados</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div>*/}
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/peticiones"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/peticiones")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faListCheck} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Peticiones</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              {/*     <div className="centrado my-2">
      <NavLink
        end
        to="/administracion/formularios"
        className=" border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={activado()}>
            <div className="icono">
              <FontAwesomeIcon icon={faClipboardCheck} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14"> Formularios</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div>*/}
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/crm"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/crm")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> CRM</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/legajos"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/legajos")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faNewspaper} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Legajos</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/admin/listaordenpago"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/admin/listaordenpago")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Ordenes de pago</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/AdminCupones"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/AdminCupones")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Cupones</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/AdminPanelInterno"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/AdminPanelInterno")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Panel Interno</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/Fidelizacion"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/Fidelizacion")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Fidelizacion</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/AdminSimulador"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/AdminSimulador")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faChartSimple} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Comparador</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/AdminComparador"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/AdminComparador")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCalculator} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Simulador</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/simuladorliquidacion"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/simuladorliquidacion")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCalculator} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Simulador de ordenes</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              {/* NUEVOS BOTONES */}
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/admin/excepcion-anticipo"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/admin/excepcion-anticipo")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Excepción Anticipo</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/admin/terminales-excepcion-anticipo"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/admin/terminales-excepcion-anticipo")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Terminales Anticipo</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              {/* <div className="centrado my-2">
      <NavLink
        end
        to="/administracion/nrocomercio"
        className=" border-0 text-decoration-none"
        onClick={() => {
          handleClose2();
          aparecerScroll();
        }}
      >
        <div style={{ width: "160px" }}>
          <div className={activado()}>
            <div className="icono">
              <FontAwesomeIcon icon={faRectangleList} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14"> Numero Comercio</span>
            </div>
          </div>
        </div>
      </NavLink>
    </div> */}
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/bancos"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/bancos")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faRectangleList} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Bancos</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/administracion/rubros"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/administracion/rubros")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faRectangleList} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14"> Rubros</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>
                  </>
              )}

              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),
      10: (
          <>
              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/diseno/notificaciones"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/diseno/notificaciones")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Notificaciones</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <NavLink
                      end
                      to="/diseno/popup"
                      className=" border-0 text-decoration-none"
                      onClick={() => {
                          handleClose2();
                          aparecerScroll();
                      }}
                  >
                      <div style={{ width: "160px" }}>
                          <div className={routeButtonClass("/diseno/popup")}>
                              <div className="icono">
                                  <FontAwesomeIcon icon={faCertificate} />
                              </div>
                              <div className="texto">
                                  <span className="lato-bold fs-14">Crear Modales</span>
                              </div>
                          </div>
                      </div>
                  </NavLink>
              </div>

              <div className="centrado my-2">
                  <button
                      onClick={confirmarCerrarSesion}
                      style={{ width: "160px" }}
                      className={
                          darkMode
                              ? "d-flex  border-0 btn-grid-menu-dark centrado"
                              : "d-flex  border-0 btn-grid-menu centrado"
                      }
                  >
                      <div className="icono">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                      </div>
                      <div className="texto">
                          <span className="lato-bold fs-14">Salir</span>
                      </div>
                  </button>
              </div>
          </>
      ),

    // menu empleado
    11: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/cajero/inicio"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/cajero/inicio")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faHouse} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Inicio</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/cajero/consultas"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/cajero/consultas")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCheckToSlot} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Consultas</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    ),
    12:(
      <>
      
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/panelinterno"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/panelinterno")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Panel Interno</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/blanqueo"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/blanqueo")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faFileInvoiceDollar} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Blanqueo</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/resumenaliado"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/resumenaliado")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Resumen Aliado</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/comparador"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/comparador")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faChartSimple} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Comparador</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/simulador"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/simulador")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faCalculator} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Simulador</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/simuladorliquidaciones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/simuladorliquidaciones")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faCalculator} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Simulador Liquidaciones</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/ordenpago"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/ordenpago")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faCalculator} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Orden de Pago</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/cupones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/cupones")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Cupones</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/nrocomercio"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/nrocomercio")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">N° de Comercio</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/abmtest/legajos"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/abmtest/legajos")}>
                <div className="icono">
                                                <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                                            </div>
                                            <div className="texto">
                                                <span className="lato-bold fs-14">Legajos</span>
                                            </div>
              </div>
            </div>
          </NavLink>
        </div>


        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    ),
    13: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/compliance/panel"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/compliance/panel")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faCertificate} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14"> Compliance</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    )
    ,
    14: (
      <>
        <div className="centrado my-2">
          <NavLink
            end
            to="/administracion/importacion-operaciones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/administracion/importacion-operaciones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faFileArrowDown} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">Importación Ops</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <NavLink
            end
            to="/administracion/conciliacion-operaciones"
            className=" border-0 text-decoration-none"
            onClick={() => {
              handleClose2();
              aparecerScroll();
            }}
          >
            <div style={{ width: "160px" }}>
              <div className={routeButtonClass("/administracion/conciliacion-operaciones")}>
                <div className="icono">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                </div>
                <div className="texto">
                  <span className="lato-bold fs-14">ConciliaciÃ³n Ops</span>
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <div className="centrado my-2">
          <button
            onClick={confirmarCerrarSesion}
            style={{ width: "160px" }}
            className={
              darkMode
                ? "d-flex  border-0 btn-grid-menu-dark centrado"
                : "d-flex  border-0 btn-grid-menu centrado"
            }
          >
            <div className="icono">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <div className="texto">
              <span className="lato-bold fs-14">Salir</span>
            </div>
          </button>
        </div>
      </>
    )
    // ... otros roles - aqui siguiendo la logica de arriba
    // y dependiendo del tipo del rol que te mande el back
    // podes ir agregando un tipo de navbar
      // para el tipo de usuario.
      // conoci gente puta en esta vida pero ninguna tanto como el nuevo diseñador
    // y eso que el anterior era puto en serio
  };

  const menuActual = menusPorRol[usuarioRol] || <></>;


  //aqui te dejo el filtrado por rol 
  // para mostrarlo o no dependiendo del usuario 
  // por lo general solo lo usa el aliado.
  const mostrarFiltroPorRol = () => {
    switch (usuarioRol) {
      case 0:
        return (
          <>
            <div>
              <button
                className="btn-filtro border-0 text-white lato-bold fs-14"
                onClick={verModalFilter}
              >
                <FontAwesomeIcon className="me-1" icon={faFilter} />
                Filtros
              </button>
            </div>
          </>
        );
      case 1:
        return (
          <>
            <div>
              <Link to="/asesores/Check">
                <FontAwesomeIcon
                  className="mx-3 color-verde fs-36"
                  icon={faLocationDot}
                  size="xl"
                />
              </Link>
            </div>
          </>
        );
      case 2:
        return (
          <div className="ocultar-div">
            <div>
              <button
                className="btn-filtro border-0 text-white lato-bold fs-14"
                onClick={verModalFilter}
              >
                <FontAwesomeIcon className="me-1" icon={faFilter} />
                Filtros
              </button>
            </div>
          </div>
        );
      case 6:
        return (
          <div className="ocultar-div">
            <div>
              <button
                className="btn-filtro border-0 text-white lato-bold fs-14"
                onClick={verModalFilter}
              >
                <FontAwesomeIcon className="me-1" icon={faFilter} />
                Filtros
              </button>
            </div>
          </div>
        );
      case 8:
        return (
          <div className="ocultar-div">
            <div>
              <button
                className="btn-filtro border-0 text-white lato-bold fs-14"
                onClick={verModalFilter}
              >
                <FontAwesomeIcon className="me-1" icon={faFilter} />
                Filtros
              </button>
            </div>
          </div>
        );
      case 11:
        return (
          <div className="ocultar-div">
            <div>
              <button
                className="btn-filtro border-0 text-white lato-bold fs-14"
                onClick={verModalFilter}
              >
                <FontAwesomeIcon className="me-1" icon={faFilter} />
                Filtros
              </button>
            </div>
          </div>
        );
      case 13:
        return (
          <div className="ocultar-div">
            <div>
              <button
                className="btn-filtro border-0 text-white lato-bold fs-14"
                onClick={verModalFilter}
              >
                <FontAwesomeIcon className="me-1" icon={faFilter} />
                Filtros
              </button>
            </div>
          </div>
        );
      default:
        return ""; 
    }
  };

  function PopoverBottom() {
    return (
      <>
        <img
          onClick={() => {
            verModalNotificacion();
            setVisible2(false);
            setHayNotificacionesNoVistas(false);
          }}
          className={activadoIconoCampana()}
          src={notificacionesIcon}
          alt="Notificaciones"
        />

        <div
          className={`crm-notification-drawer-overlay ${visible1 ? "is-open" : ""}`}
          onClick={() => setVisible1(false)}
        >
          <aside
            className={`crm-notification-drawer ${darkMode ? "is-dark" : ""} ${visible1 ? "is-open" : ""}`}
            onClick={(event) => event.stopPropagation()}
            aria-hidden={!visible1}
          >
            <div className="crm-notification-drawer-header">
              <div className="crm-notification-drawer-title">
                <img src={notificacionesIcon} alt="Notificaciones" className="crm-notification-drawer-title-icon" />
                <span>Notificaciones</span>
              </div>
              <button
                type="button"
                className="crm-notification-drawer-close"
                onClick={() => setVisible1(false)}
                aria-label="Cerrar notificaciones"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>

            <div className={`crm-notification-drawer-body ${darkMode ? "scroll-especifico-dark" : "scroll-especifico"}`}>
              {currentNotifications.length ? (
                currentNotifications.map((notificacion, index) => (
                  <article className="crm-notification-item" key={index}>
                    <h6 className="crm-notification-item-title">
                      <span className="crm-notification-item-dot" />
                      <span>{notificacion.noticia1}</span>
                    </h6>
                    {notificacion.noticia2 ? (
                      <p className="crm-notification-item-copy">{notificacion.noticia2}</p>
                    ) : null}
                  </article>
                ))
              ) : (
                <div className="crm-notification-empty">
                  No hay notificaciones para mostrar.
                </div>
              )}
            </div>
          </aside>
        </div>
      </>
    );
  }

  function PopoverBottom2() {
    const [visible2, setVisible2] = useState(false);
    const [modalShowCompleta, setModalShowCompleta] = useState(false);
    const [darkMode, setDarkMode] = useState(false); // Asegúrate de tener tu lógica para el modo oscuro

    const handleCambiarContrasena = () => {
      setModalShowCompleta(true);
      setVisible2(false);
    };

    const popover = (
      <Popover
        className={
          darkMode
            ? "caja-cerrar-sesion-dark centrado"
            : "caja-cerrar-sesion centrado"
        }
        style={{ width: "210px" }}
        id="popover-positioned-bottom"
      >
        <Popover.Body>
          <div className="container">
            <div className="py-4">
              <h6
                className={
                  darkMode
                    ? "fs-18 lato-bold text-white my-3 text-center"
                    : "fs-18 lato-bold my-3 text-center"
                }
              >
                Zoco SAS
              </h6>
              <div>
                <div className="centrado my-3">
                  <Button
                    className={
                      darkMode
                        ? "d-flex btn-nav-configuracion-dark  centrado border-0"
                        : "d-flex btn-nav-configuracion centrado  border-0"
                    }
                    onClick={handleCambiarContrasena}
                  >
                    <FontAwesomeIcon className="" icon={faGear} />
                    <span className="ms-2  lato-bold fs-10">
                      Cambiar contraseña
                    </span>
                  </Button>
                  <ModalConfiguracionesCel
                    show={modalShowCompleta}
                    onHide={() => setModalShowCompleta(false)}
                    style={{ zIndex: 1050 }} // Asegúrate de que el modal tenga un z-index alto
                  />
                </div>
              </div>
            </div>
          </div>
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
        <img
          onClick={() => setVisible2(!visible2)}
          className={activadoIconoUser()}
          src={perfilIcon}
          alt="Perfil"
        />
      </OverlayTrigger>
    );
  }

  return (
    <section className="container">
      {/* Reutiliza el diseno nuevo de la sidebar de escritorio (.sidebar-clean)
          adaptado al ancho del offcanvas. La navegacion no cambia. */}
      <Offcanvas
        className={`sidebar-clean mobile-sidebar-clean${esSidebarAliado ? " mobile-sidebar-aliado" : ""}${darkMode ? " sidebar-dark" : ""}`}
        show={mostrarOffcanvas}
        onHide={handleClose2}
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className=" text-center">
            <img
              className="my-5 img-fluid logo-width"
              src={darkMode ? logoClaro : logo}
              alt="logo SOCO"
            />
            <div className="d-flex justify-content-center align-items-center mobile-sidebar-actions">
              {/* En la sidebar de Aliados solo quedan Notificaciones y Perfil. */}
              {!esSidebarAliado && (
                <div className="zoom">
                  <FontAwesomeIcon
                    onClick={handleClick}
                    className="iconos-modales cursor-point color-verde mx-3"
                    icon={darkMode ? faSun : faMoon}
                  />
                </div>
              )}

              <div className="zoom" style={{ position: "relative" }}>
                {hayNotificacionesNoVistas && (
                  <NotificacionIndicador count={"!"} />
                )}
                {PopoverBottom()}
              </div>
              <div className="zoom">
                <img
                  onClick={() => setModalShowCompleta(true)}
                  className={activadoIconoUser()}
                  src={perfilIcon}
                  alt="Perfil"
                />
                <ModalConfiguracionesCel
                  show={modalShowCompleta}
                  onHide={() => setModalShowCompleta(false)}
                />
              </div>
            </div>
          </div>
          {/* botones navlink */}
          {menuActual}
        </Offcanvas.Body>
      </Offcanvas>
      <section
        className={
          darkMode ? " mobile-nav-menu-dark py-4" : "mobile-nav-menu py-4"
        }
      >
        <div className="container d-flex justify-content-between centrado">
          <div className="">
            <Button
              variant="primary"
              onClick={() => setMostrarOffcanvas(true)}
              className={
                darkMode
                  ? "mobile-nav-btn-fabars-dark"
                  : "mobile-nav-btn-fabars"
              }
            >
              <FaBars size={25} />
            </Button>
          </div>
          <div className="">
            <div>
              <img
                className="logo img-fluid "
                src={darkMode ? logoClaro : logo}
                alt="logo"
              />
            </div>
          </div>
          <div>{mostrarFiltroPorRol()}</div>
        </div>
        {visibleModal && (
          <div className="modalShadowFilter aliado-filtros-overlay">
            <div
              className={`aliado-filtros-panel${darkMode ? " is-dark" : ""}`}
            >
              <header className="aliado-filtros-topbar">
                <img
                  className="aliado-filtros-logo"
                  src={darkMode ? logoClaro : logo}
                  alt="Zoco"
                />
                <button
                  type="button"
                  className="aliado-filtros-close"
                  onClick={verModalFilter}
                  aria-label="Cerrar filtros"
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </header>

              <div className="aliado-filtros-title">
                <span>Completa los</span>
                <h2>Filtros de búsqueda</h2>
              </div>

              <form className="aliado-filtros-form">
                <article className="aliado-filtros-field">
                  <label className="aliado-filtros-label" htmlFor="filtro-anio">Año</label>
                  <Select
                    inputId="filtro-anio"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    maxMenuHeight={220}
                    aria-label="Año"
                    placeholder="Año"
                    value={selectedAnio}
                    className="lato-bold"
                    classNamePrefix="aliado-select"
                    isSearchable={isSearchable}
                    name="anio"
                    options={optionsAnios}
                    onChange={(selectedOption) => {
                      // Convertir el valor seleccionado a un número antes de establecer el estado
                      setSelectedAnio({
                        ...selectedOption,
                        value: Number(selectedOption.value),
                      });
                      actualizarMesesPorAnio(Number(selectedOption.value));
                      setSelectedSemana({ value: 8, label: "Todo el Mes" });
                    }}
                    styles={filtrosSelectStyles}
                  />
                </article>
                <article className="aliado-filtros-field">
                  <label className="aliado-filtros-label" htmlFor="filtro-mes">Mes</label>
                  <Select
                    inputId="filtro-mes"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    maxMenuHeight={220}
                    aria-label="Mes"
                    placeholder="Mes"
                    value={selectedMes}
                    className="lato-bold"
                    classNamePrefix="aliado-select"
                    isSearchable={isSearchable}
                    name="mes"
                    options={optionsMes}
                    onChange={(selectedOption) => {
                      setSelectedMes(selectedOption);
                      actualizarSemanasPorMes(
                        selectedAnio.value,
                        selectedOption.value
                      );
                      setSelectedSemana({ value: 8, label: "Todo el Mes" });
                    }}
                    styles={filtrosSelectStyles}
                  />
                </article>
                <article className="aliado-filtros-field">
                  <label className="aliado-filtros-label" htmlFor="filtro-semanas">Semana del mes</label>
                  <Select
                    inputId="filtro-semanas"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    maxMenuHeight={220}
                    aria-label="Semana del mes"
                    placeholder="Semana del mes"
                    value={selectedSemana}
                    className="lato-bold"
                    classNamePrefix="aliado-select"
                    isSearchable={isSearchable}
                    name="semanas"
                    options={optionsSemanas}
                    onChange={(selectedOption) => {
                      setSelectedSemana(selectedOption);
                    }}
                    styles={filtrosSelectStyles}
                  />
                </article>
                <article className="aliado-filtros-field">
                  <label className="aliado-filtros-label" htmlFor="filtro-comercio">Comercio</label>
                  <Select
                    inputId="filtro-comercio"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    maxMenuHeight={220}
                    aria-label="Comercio"
                    placeholder="Comercio"
                    value={selectedComercio}
                    className=" lato-bold"
                    classNamePrefix="aliado-select"
                    isSearchable={isSearchable}
                    name="comercio"
                    options={optionsComercio}
                    onChange={(selectedOption) => {
                      setSelectedComercio(selectedOption);
                    }}
                    styles={filtrosSelectStyles}
                  />
                </article>

                <button
                  className="aliado-filtros-apply lato-bold"
                  type="button"
                  onClick={handleEnviarDatos}
                  disabled={isLoading}
                >
                  {isLoading ? "Cargando..." : "Aplicar"}
                </button>

                <button
                  className="aliado-filtros-clear lato-bold"
                  type="button"
                  onClick={handleBorrarFiltros}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                  <span>Borrar filtros</span>
                </button>
              </form>
            </div>
          </div>
        )}
      </section>
    </section>
  );
};

export default NuevoNavReact;
